import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const APP_TITLE = 'StatusNow — ASM Group';

/** Browser tab title for a page, e.g. "Claims · StatusNow". */
export function pageTitle(page: string): string {
  return `${page} · StatusNow`;
}

/**
 * Sets the browser tab title from the active route's `title` property as
 * "&lt;Page> · StatusNow" (e.g. "Claims · StatusNow"), falling back to the
 * app title for routes that don't declare one.
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const page = this.buildTitle(snapshot);
    this.title.setTitle(page ? pageTitle(page) : APP_TITLE);
  }
}
